<template>
  <main class="page login-page">
    <div class="first-screen _container">
      <div class="page-heading">
        <h6>Login</h6>
      </div>
      <LoginForm @close="onLoginFormClose"/>
    </div>
  </main>
</template>


<script>
import { useHead } from '@vueuse/head';

import LoginForm from '@/components/forms/login';


export default {
    name: 'Login',
    components: {LoginForm},

    setup() {
        useHead({
            title: 'Client Area - Login - Kendoo',
            meta: [{
                name: 'description',
                content: 'Kendoo delivers a high-performing portfolio of slot games to online casino platforms and aggregators.'
            }]
        });
    },

    methods: {
      onLoginFormClose(e) {
        if (e && e.pageReload) this.$router.go();
      }
    }

}
</script>
